import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { COUNTRYINFO } from "data/country";
import { IonCheckbox } from "@ionic/react";
import { getLanguage } from "config/language";
import { useDispatch, useSelector } from "react-redux";
import { parseNumber } from "libphonenumber-js";
import Auth from "services/Auth";
import { Link, useNavigate } from "react-router-dom";
import { setCreateUser } from "redux/container/userSlice";

export default function PhoneNumber({
	sSize,
	phoneNo,
	setPhoneNo,
	country,
	setCountry,
	countryCode,
	setCountryCode,
}) {
	const [isChecked, setIsChecked] = useState(false);
	const ekkLanguage = useSelector((state) => state.lan);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [spamE, setSpamE] = useState("");

	var countryList = Object.values(COUNTRYINFO).map((val) => ({
		countryCode: val.code,
		country: val.name,
		value: val.code,
		label: (
			<div className='flex items-center'>
				<img
					src={val.flag}
					className='h-[20px] lg:h-auto lg:w-10 w-5 rounded-[5px]'
					alt='flag'></img>{" "}
				<p className='text-14 pl-2'>{val.code}</p>
			</div>
		),
	}));
	const handleSelectCountry = (e) => {
		setCountryCode(e.countryCode);
		setCountry(e.country);
	};
	let clickBtnRef = useRef(null);
	const _handleKeyPress = (e) => {
		if (e.key === "Enter") {
			clickBtnRef.current.click();
		}
	};
	let customStyles = {
		option: (provided, state) => ({
			...provided,
			zIndex: 10,
			paddingLeft: 30,
		}),
		singleValue: (provided, state) => ({
			...provided,
			borderWidth: 0,
			height: sSize.matches ? 50 : 60,
			borderRadius: 0,
			display: "flex",
			fontSize: sSize.matches ? 16 : 24,
		}),
		control: (provided, state) => ({
			...provided,
			color: "red",
			borderRadius: 15,
			borderWidth: 1,
			border: "1px solid #00000026",
			outLine: "none",
			height: sSize.matches ? 50 : 60,
			paddingLeft: sSize.matches ? 10 : 20,
			fontSize: sSize.matches ? 16 : 24,
			//   borderBottomLeftRadius: 5,
			//   borderTopLeftRadius: 5,
		}),
	};
	const handleOnChange = (e) => {
		setIsChecked(!isChecked);
	};
	const errorMessage = () => {
		if (phoneNo) {
			if (country === "Bangladesh") {
				if (
					!(
						phoneNo.trim().length > 10 &&
						phoneNo.trim().length < 12 &&
						phoneNo[0] == 0
					)
				) {
					return ekkLanguage?.lan.login.validationLabel;
				} else {
					return "";
				}
			} else {
				if (
					!Object.keys(parseNumber(countryCode + phoneNo)).length &&
					phoneNo.trim().length > 0
				) {
					return ekkLanguage?.lan.login.validationLabel;
				} else {
					return "";
				}
			}
		}
	};

	//submit country verificarion handler, it's verify first country and phone no.
	const submitPhoneNumberCountry = async (
		countryCode,
		country,
		phoneNumber
	) => {
		if (country === "Bangladesh") {
			if (
				!(
					phoneNo.trim().length > 10 &&
					phoneNo.trim().length < 12 &&
					phoneNo[0] == 0
				)
			) {
				// toast.error(ekkLanguage?.lan?.login.validationLabel);
				return;
			}
		}
		// let pn = parseNumber(countryCode + phoneNo).phone;
		let req_body = {
			country,
			phone_number: (countryCode + phoneNo).trim(),
		};

		try {
			// startLoading();
			let response = await Auth.countryAndUserFilter(req_body);
			if (response.status === 200) {
				let data = {
					countryCode,
					country,
					phoneNumber,
					verify: false,
				};
				dispatch(setCreateUser(data));
				navigate("/password");
			} else {
				let data = {
					countryCode,
					country,
					phoneNumber,
					verify: true,
				};
				dispatch(setCreateUser(data));
				navigate("/registration-new-user");
			}
			// stopLoading();
		} catch (e) {
			// stopLoading();
			console.log(e);
		}
	};
	const numberInputRef = useRef(null);
	useEffect(() => {
		const handleWheel = (event) => {
			if (
				numberInputRef.current &&
				numberInputRef.current === document.activeElement
			) {
				event.preventDefault();
			}
		};
		window.addEventListener("wheel", handleWheel, { passive: false });
		return () => {
			window.removeEventListener("wheel", handleWheel);
		};
	}, []);

	return (
		<div className='bg-white lg:p-12 p-8 rounded-2xl shadow-xl lg:w-1/2 w-full backdrop-blur-sm bg-opacity-95 transform transition-all duration-300 hover:shadow-2xl'>
			<div className='mb-6'>
				<h3 className='text-2xl md:text-3xl font-bold text-gray-800 mb-2'>
					{ekkLanguage?.lan?.landing.welcomeBack || 'Welcome Back'}
				</h3>
				<p className='text-gray-600'>Enter your phone number to continue</p>
			</div>
			<label
				className='text-sm md:text-base font-semibold text-gray-700 mb-2 block'>
				{ekkLanguage?.lan?.landing.phoneNumber}
			</label>
			<div className='flex gap-3 z-10 relative'>
				<Select
					styles={customStyles}
					className='basic-single w-[250px]'
					placeholder='+88'
					name='color'
					options={countryList}
					onChange={(e) => handleSelectCountry(e)}
					components={{
						IndicatorSeparator: () => null,
					}}
					style={{ fontSize: sSize.matches ? 14 : 20 }}
					defaultValue={{
						countryCode: "+88",
						country: "Bangladesh",
						value: "+88",
						label: (
							<div className='flex items-center'>
								<img
									src='https://ekkfilesdbt.blob.core.windows.net/images/ekkflags-bangladesh.png'
									className='h-[20px] lg:h-auto lg:w-10 w-5 rounded-[5px]'
									alt='flag'></img>{" "}
								<p className='text-14 pl-2'>+88</p>
							</div>
						),
					}}
				/>

				<input
					ref={numberInputRef}
					type='number'
					onKeyPress={_handleKeyPress}
					onChange={(event) => {
						setSpamE("");
						setPhoneNo(event.target.value);
					}}
					placeholder={ekkLanguage?.lan?.landing.phoneNumberPlaceHolder}
					id={"ekk-input"}
					className='flex-1 appearance-none text-base px-4 py-3 md:py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200'
				/>
			</div>
			{(spamE || errorMessage()) && (
				<div className='mt-3 flex items-center gap-2 text-red-600 text-sm'>
					<svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
						<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
					</svg>
					<p>{spamE || errorMessage()}</p>
				</div>
			)}

			{/* <div className='trams-condition pt-2 pb-5 sm:pb-[20px]'>
				<label className='flex cursor-pointer my-2'>
					<IonCheckbox
						color='success'
						size='small'
						slot='start'
						value='terms'
						className='mr-2 checkbox-square'
						checked={isChecked}
						onIonChange={handleOnChange}></IonCheckbox>
					{getLanguage() == "en" ? (
						<p className='flex-1 text-12'>
							I agree with the EkkBaz's{" "}
							<Link
								to='/terms-conditions'
								className='text-delivered text-12'
								rel='noreferrer'>
								Terms & Conditions
							</Link>
							,{" "}
							<Link
								to='/privacy-policy'
								className='text-delivered text-12'
								rel='noreferrer'>
								{" "}
								Privacy Policy{" "}
							</Link>{" "}
							and{" "}
							<Link
								to='/refund-policy'
								className='text-delivered text-12'
								rel='noreferrer'>
								Refund Policy
							</Link>
							.
						</p>
					) : getLanguage() == "bn" ? (
						<p className='flex-1 text-12'>
							আমি EkkBaz এর{" "}
							<Link
								to='/terms-conditions'
								className='text-delivered'
								rel='noreferrer'>
								টার্মস & কন্ডিশনস
							</Link>
							,{" "}
							<Link
								to='/privacy-policy'
								className='text-delivered'
								rel='noreferrer'>
								{" "}
								প্রাইভেসী পলিসি{" "}
							</Link>{" "}
							এবং{" "}
							<Link
								to='/refund-policy'
								className='text-delivered'
								rel='noreferrer'>
								রিফান্ড পলিসি
							</Link>{" "}
							সাথে একমত।
						</p>
					) : (
						<p className='flex-1 text-12'>
							Tôi thuộc EkkBaz{" "}
							<Link
								to='/terms-conditions'
								className='text-delivered'
								rel='noreferrer'>
								Điều khoản & Điều kiện
							</Link>
							,{" "}
							<Link
								to='/privacy-policy'
								className='text-delivered'
								rel='noreferrer'>
								{" "}
								Chính sách bảo mật{" "}
							</Link>{" "}
							Và{" "}
							<Link
								to='/refund-policy'
								className='text-delivered'
								rel='noreferrer'>
								Chính sách hoàn tiền
							</Link>{" "}
							Tôi đồng ý.
						</p>
					)}
				</label>
			</div> */}
			<button
				ref={clickBtnRef}
				onClick={() => {
					submitPhoneNumberCountry(countryCode, country, phoneNo);
				}}
				className='mt-6 w-full py-4 md:py-5 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-lg md:text-xl font-bold rounded-xl hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-orange-200 flex items-center justify-center gap-2'>
				{ekkLanguage?.lan?.landing.login}
				<svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
					<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 7l5 5m0 0l-5 5m5-5H6' />
				</svg>
			</button>
		</div>
	);
}
